import {Component, computed, inject, input} from "@angular/core";
import {DatePipe} from "@angular/common";
import {EnumLabel, EnumLabelPipe} from "../../../shared/shared-pipes/enum-label.pipe";
import {MatChip} from "@angular/material/chips";
import {MatIcon} from "@angular/material/icon";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {Gender, ParticipantType, SimUser} from "@models";
import {Translations} from "@translations";

@Component({
	selector: "sim-user-details",
	standalone: true,
	imports: [DatePipe, EnumLabelPipe, MatChip, MatIcon, TranslateModule],
	templateUrl: "./user-details.component.html",
	styleUrl: "./user-details.component.scss",
})
export class UserDetailsComponent {
	readonly translate = inject(TranslateService);
	// I/O
	public readonly user = input.required<SimUser | null>();
	public readonly participantType = input<ParticipantType>(ParticipantType.Unknown);

	// Constants
	protected readonly Gender = Gender;
	protected readonly T = Translations;
	protected readonly EnumLabel = EnumLabel;

	protected readonly typeIcon = computed<"fa-user-graduate" | "fa-user-injured" | "fa-user-md" | "fa-user">(() => {
		switch (this.participantType()) {
			case ParticipantType.Learner:
				return "fa-user-graduate";
			case ParticipantType.StandardizedPatient:
				return "fa-user-injured";
			case ParticipantType.Instructor:
				return "fa-user-md";
			default:
				return "fa-user";
		}
	});
}
